// const backend_origin = process.env.REACT_APP_STUDIO_WEB_API;
export const AWS_URL = process.env.REACT_APP_AWS_URL;

// export const API_URL = backend_origin;

export const API_URL = process.env.REACT_APP_STUDIO_WEB_API;
